var _path, _rect, _rect2, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCctv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89567 10.7709C4.89567 9.68932 5.77245 8.81254 6.854 8.81254H37.351C38.8068 8.81254 39.7537 10.3446 39.1026 11.6467L36.5391 16.7737C35.3781 19.0957 33.0047 20.5625 30.4086 20.5625H11.7498C7.96439 20.5625 4.89567 17.4938 4.89567 13.7084V10.7709Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.89567,
    y: 28.3957,
    width: 5.875,
    height: 9.79167,
    rx: 2.9375,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6457,
    y: 24.4793,
    width: 3.91667,
    height: 9.79167,
    rx: 1.95833,
    transform: "rotate(-90 16.6457 24.4793)",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5417 24.479V27.4165C21.5417 30.6612 18.9113 33.2915 15.6667 33.2915H11.75",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1667 11.7501H40.1458C41.2274 11.7501 42.1042 12.6269 42.1042 13.7085V17.6251C42.1042 18.7067 41.2274 19.5835 40.1458 19.5835H35.25",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9665,
    cy: 14.8835,
    r: 0.597292,
    stroke: "#1C1C1C",
    strokeWidth: 1.15542
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.883,
    cy: 14.8835,
    r: 0.597292,
    stroke: "#1C1C1C",
    strokeWidth: 1.15542
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctv);
export default __webpack_public_path__ + "static/media/CCTV.6d58a128847f4e887da55d1485273d90.svg";
export { ForwardRef as ReactComponent };